import { createSlice } from "@reduxjs/toolkit";

import { addWebSocketCases } from "../helpers/storeAction";
import { fetchEmailHistoryListData } from "../thunks/emailHistory";

import type { EmailHistory } from "../../utils/types/emailHistory";

interface EmailHistoryListState {
  EmailHistoryList: EmailHistory[];
  loading: boolean;
  error: string | null;
  total: number;
}

const initialState: EmailHistoryListState = {
  EmailHistoryList: [],
  loading: false,
  error: null,
  total: 0,
};

export const emailHistoryListSlice = createSlice({
  name: "emailHistoryList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailHistoryListData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmailHistoryListData.fulfilled, (state, action) => {
        state.EmailHistoryList = action.payload?.data || [];
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(fetchEmailHistoryListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });

    addWebSocketCases(builder, "emailHistoryList", "EmailHistoryList");
  },
});

export default emailHistoryListSlice.reducer;
